import React, { useState } from "react";
import backgroundImg from "../assets/imgaeBackground.png";
import logikeepImg from "../assets/logikeep.PNG";
import bookImg from "../assets/Book.PNG";
import eshopImg from "../assets/eshop.PNG";
import Labour from "../assets/labourmarket.PNG";
import bookVideo from "../assets/bookvideo.mp4";
import "animate.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import {
  faCodepen,
  faTelegram,
  faGithub,
} from "@fortawesome/free-brands-svg-icons";
import { Link } from "react-router-dom";
import PreviewModal from "./previewModal";
import FitVideo from "../assets/fitbyfitmovie.MP4";
import AddGoalsVideo from "../assets/addgoalsVideo.mp4";
import AddGoals from "../assets/iphoneFrame2.png";
import IphoneFrame from "../assets/iphoneFrame1.png";

const projects = [
  {
    id: 1,
    title: "Logikeep Africa",
    description:
      "Logikeep simplifies and enhances bookkeeping processes, delivering both efficiency and ease of use.",
    imageUrl: logikeepImg, // Replace with your image or video URL
    projectLink: "https://logikeep.africa/",
  },
  {
    id: 2,
    title: "My Book",
    description:
      "MyBook allows users to effortlessly read their chosen books. It also provides librarians with the functionality to add new books to the collection.",
    imageUrl: bookImg,
    videoUrl: bookVideo,
  },
  {
    id: 3,
    title: "Eshop Africa",
    description:
      "Eshop is committed to making international shopping accessible from anywhere in Africa.",
    imageUrl: eshopImg,
    projectLink: "https://eshopafrica.co/",
  },
  {
    id: 4,
    title: "Labour Market",
    description:
      "LabourMarket is an innovative platform created to connect job seekers with employers effortlessly.",
    imageUrl: Labour,
    projectLink: "https://labour-market.vercel.app/",
  },
  // Add more projects as needed
];

const mobileprojects = [
  {
    id: 1,
    title: "FitbyFit",
    description:
      "FitbyFit is the all-in-one fitness app. Set weight loss goals, track calories, and get exercise suggestions.",
    imageUrl: IphoneFrame,
    mobileUrl: FitVideo,
  },
  {
    id: 2,
    title: "Add Goals",
    description:
      "This project represents a personal journey of discovery, focused on advancing proficiency in React Native. AddGoals offers users a seamless experience in setting and managing their goals.",
    imageUrl: AddGoals,
    mobileUrl: AddGoalsVideo,
  },
  // {
  //   id: 3,
  //   title: "Eshop Africa",
  //   description:
  //     "Eshop is committed to making international shopping accessible from anywhere in Africa.",
  //     imageUrl: IphoneFrame,
  //     mobileUrl: FitVideo,
  // },
];

export default function Portfolio() {
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [selectedMobileVideo, setSelectedMobileVideo] = useState(null);

  const handleViewProject = (videoUrl) => {
    setSelectedVideo(videoUrl);
  };
  const handleViewMobileProject = (mobileUrl) => {
    setSelectedMobileVideo(mobileUrl);
  };

  const closeModal = () => {
    setSelectedVideo(null);
  };
  const closeMobileModal = () => {
    setSelectedMobileVideo(null);
  };

  return (
    <div
      style={{
        backgroundImage: `url(${backgroundImg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        minHeight: "100vh",
      }}
    >
      <div className="p-8 py-4">
        <div className="grid grid-cols-1 md:grid-cols-1 gap-4 md:mt-24">
          <div className="bg-gradient-to-r from-orange-200 via-pink-300 to-red-400 p-4 md:col-span-2 rounded-md">
            <div className="flex items-center justify-between">
              <h1 className="text-5xl mt-2 font-bold animate__animated animate__fadeInBottomLeft">
                <Link to="/" className="text-4xl ">
                  <FontAwesomeIcon icon={faCodepen} />
                </Link>{" "}
                Projects.{" "}
                <span>
                  <a
                    href="https://github.com/thebadmos"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="rounded-lg bg-pink-300 text-center px-4 py-2 text-sm text-black font-semibold"
                  >
                    <FontAwesomeIcon
                  icon={faCodepen}
                  className="mr-2 md:mr-2 md:mb-0"
                />
                    <span className="" >Github</span>
                  </a>
                </span>
              </h1>

              <div>
                <Link to="/" className="text-2xl">
                  <FontAwesomeIcon icon={faArrowLeft} />
                </Link>
              </div>
            </div>

            <div className="flex items-center mt-4">
              <div className="rounded-lg bg-pink-300 w-full sm:w-48 hover:bg-pink-200 flex justify-center items-center h-12 text-lg font-semibold">
                Web Development
              </div>
              <Link to="/" className="text-xl ml-2 mr-2 hidden sm:flex">
                <FontAwesomeIcon icon={faArrowRight} />
              </Link>
              <div className="flex items-center justify-between hidden sm:flex">
                <div className="rounded-full bg-pink-200 text-center px-4 py-2 text-sm text-black font-semibold">
                  ReactJs
                </div>
                <div className="rounded-full bg-pink-200 text-center px-4 py-2 text-sm text-black font-semibold mx-4">
                  Tailwind Css
                </div>
                <div className="rounded-full bg-pink-200 text-center px-4 py-2 text-sm text-black font-semibold">
                  Redux
                </div>
                <div className="rounded-full bg-pink-200 text-center px-4 py-2 text-sm text-black font-semibold mx-4">
                  API Integration
                </div>
                <div className="rounded-full bg-pink-200 text-center px-4 py-2 text-sm text-black font-semibold">
                  Styled Component
                </div>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
              {projects.map((project) => (
                <div key={project.id} className="relative group">
                  <img
                    src={project.imageUrl}
                    alt={project.title}
                    className="w-full h-48 object-cover rounded-md shadow-lg"
                  />
                  <div className="absolute inset-0 bg-pink-300 bg-opacity-75 flex flex-col justify-center items-center text-black opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-md">
                    <h2 className="text-2xl font-bold mb-2">{project.title}</h2>
                    <p className="text-center mb-4 text-sm font-bold">
                      {project.description}
                    </p>
                    {project.videoUrl ? (
                      <button
                        onClick={() => handleViewProject(project.videoUrl)}
                        className="text-black text-sm underline"
                      >
                        <FontAwesomeIcon icon={faTelegram} className="mr-1" />
                        View Demo
                      </button>
                    ) : (
                      <a
                        href={project.projectLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-black text-sm underline"
                      >
                        <Link to="/" className="text-sm mr-1">
                          <FontAwesomeIcon icon={faTelegram} />
                        </Link>
                        View Project
                      </a>
                    )}
                  </div>
                </div>
              ))}
            </div>

            <div className="flex items-center mt-6">
              <div className="rounded-lg bg-pink-300 w-full sm:w-48 hover:bg-pink-200 flex justify-center items-center h-12 text-lg font-semibold">
                Mobile Development
              </div>

              <Link to="/" className="text-xl ml-2 mr-2 hidden sm:flex">
                <FontAwesomeIcon icon={faArrowRight} />
              </Link>
              <div className="flex items-center justify-between hidden sm:flex">
                <div className="rounded-full bg-pink-200 text-center px-4 py-2 text-sm text-black font-semibold">
                  React Native
                </div>
                <div className="rounded-full bg-pink-200 text-center px-4 py-2 text-sm text-black font-semibold mx-4">
                  Css
                </div>
                <div className="rounded-full bg-pink-200 text-center px-4 py-2 text-sm text-black font-semibold">
                  Async Storage
                </div>
                <div className="rounded-full bg-pink-200 text-center px-4 py-2 text-sm text-black font-semibold mx-4">
                  API Integration
                </div>
                <div className="rounded-full bg-pink-200 text-center px-4 py-2 text-sm text-black font-semibold">
                  Tailwind Css
                </div>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
              {mobileprojects.map((project) => (
                <div
                  key={project.id}
                  className="relative group flex justify-center"
                >
                  <img
                    src={project.imageUrl}
                    alt={project.title}
                    className="w-full h-auto max-w-x s md:max-w-none object-cover rounded-md shadow-lg"
                  />
                  <div className="absolute inset-0 bg-pink-300 bg-opacity-75 flex flex-col justify-center items-center text-black opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-md">
                    <h2 className="text-2xl font-bold mb-2">{project.title}</h2>
                    <p className="text-center mb-4 text-sm font-bold">
                      {project.description}
                    </p>
                    <button
                      onClick={() => handleViewMobileProject(project.mobileUrl)}
                      className="text-black text-sm underline"
                    >
                      <FontAwesomeIcon icon={faTelegram} className="mr-1" />
                      View Demo
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {selectedVideo && (
        <PreviewModal videoUrl={selectedVideo} onClose={closeModal} />
      )}

      {selectedMobileVideo && (
        <PreviewModal
          mobileUrl={selectedMobileVideo}
          onClose={closeMobileModal}
        />
      )}
    </div>
  );
}
